/** Bake-time hint and prep notes the server attaches to a baker task. */
export default function BakerPrepIntel({ info }) {
  if (!info || info.role !== "baker") return null;
  const prep = info.prep_instructions;
  const hint = info.bake_time_hint;
  if (!prep && !(hint && hint.text)) return null;
  return (
    <div className="mt-4 space-y-2">
      {hint && hint.text ? (
        <div className="rounded-2xl border border-amber-300 bg-amber-50 px-3 py-2">
          <p className="text-[11px] font-extrabold uppercase tracking-wide text-amber-800">
            Bake time
          </p>
          <p className="mt-0.5 text-sm font-bold text-amber-900">{hint.text}</p>
        </div>
      ) : null}
      {prep ? (
        <div className="rounded-2xl border border-sky-300 bg-sky-50 px-3 py-2">
          <p className="text-[11px] font-extrabold uppercase tracking-wide text-sky-800">
            {prep.title || "Prep notes"}
          </p>
          <p className="mt-0.5 text-sm font-semibold leading-snug text-sky-900">{prep.text}</p>
        </div>
      ) : null}
    </div>
  );
}
